import { render, staticRenderFns } from "./DeliveryDriverList.vue?vue&type=template&id=189ac087&"
import script from "./DeliveryDriverList.vue?vue&type=script&lang=js&"
export * from "./DeliveryDriverList.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryDriverList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports